import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
import { PadCollapse } from 'app/shared/components/misc';
import Body from 'app/shared/components/typography/body/Body';
import Heading from 'app/shared/components/typography/heading/Heading';
import React from 'react';

export default function ProductDatabaseLookupFailed(): JSX.Element {
  return (
    <>
      <Icon icon={IconLib.SEARCH} soloContentStyle />
      <Heading color="primary">
        iWarranty is yet to onboard this barcode
      </Heading>
      <PadCollapse pad={2} />
      <Body>If you want, try a different product</Body>
      <Button navBackAction startIcon={IconLib.CHEVRON_LEFT}>
        Back to barcode lookup
      </Button>
      <Body>
        Otherwise search our catalogue, or enter your product manually
      </Body>
      <Button
        to={ConsumerRoutePath.PRODUCT_SEARCH_CATALOG}
        startIcon={IconLib.PAGE}
      >
        Search by product name
      </Button>
      <Button
        to={ConsumerRoutePath.MANUAL_PRODUCT_ENTRY}
        startIcon={IconLib.EDIT}
      >
        Add product manually
      </Button>
    </>
  );
}
